import React from 'react';
export function Footer() {
  return <footer id="contact" className="relative bg-[#1A1A1A] text-[#F5F3F0] pt-24 pb-12 border-t border-[#252525]" data-id="element-67">
      {/* Heavy timber texture */}
      <div className="absolute inset-0 texture-timber opacity-20" data-id="element-68" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-70">
          <div className="md:col-span-1" data-id="element-71">
            <img src="https://cdn.magicpatterns.com/uploads/rsVSuidRepyz9oxNYVg3rK/Iron_Ridge_Logo.png" alt="Iron Ridge Custom Homes" className="h-16 w-auto mb-4 brightness-[10] contrast-[0.9]" data-id="element-72" />
            <p className="text-[#D4CFC8]/60 text-sm leading-relaxed mb-6" data-id="element-73">
              Crafting bespoke homes that stand the test of time. Where heritage
              meets innovation in Northern Idaho.
            </p>
          </div>

          <div data-id="element-74">
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#A07656] mb-6" data-id="element-75">
              Explore
            </h4>
            <ul className="space-y-4 text-sm text-[#D4CFC8]/80" data-id="element-76">
              <li data-id="element-77">
                <a href="#" onClick={e => {
                e.preventDefault();
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              }} className="hover:text-white transition-colors" data-id="element-78">
                  Home
                </a>
              </li>
              <li data-id="element-79">
                <a href="#portfolio" onClick={e => {
                e.preventDefault();
                document.getElementById('portfolio')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="hover:text-white transition-colors" data-id="element-80">
                  Portfolio
                </a>
              </li>
              <li data-id="element-81">
                <a href="#about" onClick={e => {
                e.preventDefault();
                document.getElementById('about')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="hover:text-white transition-colors" data-id="element-82">
                  About
                </a>
              </li>
              <li data-id="element-83">
                <a href="#field-notes" onClick={e => {
                e.preventDefault();
                document.getElementById('field-notes')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="hover:text-white transition-colors" data-id="element-84">
                  Blogs
                </a>
              </li>
              <li data-id="element-85">
                <a href="#contact" onClick={e => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="hover:text-white transition-colors" data-id="element-86">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-87">
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#A07656] mb-6" data-id="element-88">
              Contact
            </h4>
            <ul className="space-y-4 text-sm text-[#D4CFC8]/80" data-id="element-89">
              <li data-id="element-90">3951 S Mellick Rd.</li>
              <li data-id="element-91">Post Falls, ID 83854</li>
              <li className="pt-2" data-id="element-92">
                <a href="tel:+12087550488" className="hover:text-white transition-colors" data-id="element-93">
                  (208) 755-0488
                </a>
              </li>
              <li data-id="element-94">
                <a href="mailto:Jake@ironridgech.com" className="hover:text-white transition-colors" data-id="element-95">
                  Jake@ironridgech.com
                </a>
              </li>
              <li data-id="element-96">
                <a href="mailto:Richard@ironridgech.com" className="hover:text-white transition-colors" data-id="element-97">
                  Richard@ironridgech.com
                </a>
              </li>
              <li data-id="element-98">
                <a href="mailto:Brandon@ironridgech.com" className="hover:text-white transition-colors" data-id="element-99">
                  Brandon@ironridgech.com
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-1 flex flex-col justify-between" data-id="element-100">
            <div className="border-2 border-[#A07656]/30 p-6 text-center bg-[#252525]/50" data-id="element-101">
              <span className="block text-3xl font-serif font-bold text-[#A07656] mb-1" data-id="element-102">
                45+
              </span>
              <span className="text-xs uppercase tracking-widest text-[#D4CFC8]/60 font-medium" data-id="element-103">
                Years Combined Experience
              </span>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#252525] flex justify-center items-center text-xs text-[#D4CFC8]/40" data-id="element-104">
          <p data-id="element-105">
            &copy; {new Date().getFullYear()} Iron Ridge Custom Homes. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}